import React from "react";
import styled from "styled-components";
//
import Header from "./header";
import Main from "./main";
//

export default ({ image, ...rest }) => (
  <Wrap>
    <img src={image.url} alt="takriko" />
    <Header {...rest} />
    <Main {...rest} />
  </Wrap>
);
//
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
  }
`;
